/* Booking-style counter row with +/- buttons and inline numeric input. */
export default function CounterRow({ label, value, min = 0, max = 99, onChange, testId }) {
  return (
    <div className="flex items-center justify-between py-2.5" data-testid={`${testId}-row`}>
      <div className="text-[#1E3A5F] font-semibold">{label}</div>
      <div className="flex items-center gap-3">
        <button
          type="button"
          onClick={() => value > min && onChange(value - 1)}
          disabled={value <= min}
          aria-label={`Diminuisci ${label}`}
          data-testid={`${testId}-dec`}
          className="w-9 h-9 rounded-full border-2 border-[#AC5D45] text-[#AC5D45] hover:bg-[#AC5D45]/10 disabled:border-[#E8E2D9] disabled:text-[#E8E2D9] disabled:cursor-not-allowed transition flex items-center justify-center text-lg font-bold"
        >−</button>
        <input
          type="text"
          inputMode="numeric"
          value={value}
          onChange={(e) => {
            const n = parseInt(e.target.value.replace(/\D/g, "")) || min;
            onChange(Math.max(min, Math.min(max, n)));
          }}
          className="w-10 text-center font-display text-lg font-semibold text-[#1E3A5F] bg-transparent border-0 outline-none focus:ring-2 focus:ring-[#AC5D45]/30 rounded"
          data-testid={`${testId}-input`}
          aria-label={label}
        />
        <button
          type="button"
          onClick={() => value < max && onChange(value + 1)}
          disabled={value >= max}
          aria-label={`Aumenta ${label}`}
          data-testid={`${testId}-inc`}
          className="w-9 h-9 rounded-full border-2 border-[#AC5D45] text-[#AC5D45] hover:bg-[#AC5D45]/10 disabled:border-[#E8E2D9] disabled:text-[#E8E2D9] disabled:cursor-not-allowed transition flex items-center justify-center text-lg font-bold"
        >+</button>
      </div>
    </div>
  );
}
